import { Pencil, Trash2, Ticket } from 'lucide-react';
import type { PromotionCompany } from '../../types/promotion';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  Button,
  EmptyState
} from '../ui';

interface CompanyListProps {
  companies: PromotionCompany[];
  onEdit: (company: PromotionCompany) => void;
  onDelete: (company: PromotionCompany) => void;
  onManageCoupons: (company: PromotionCompany) => void;
  isLoading?: boolean;
}

function CompanyList({
  companies,
  onEdit,
  onDelete,
  onManageCoupons,
  isLoading,
}: CompanyListProps) {
  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (companies.length === 0) {
    return (
      <EmptyState
        icon={<Ticket className="h-12 w-12" />}
        title="Nenhuma empresa participante"
        description="Adicione empresas para participar desta campanha"
      />
    );
  }

  return (
    <TableContainer>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Empresa</TableHead>
            <TableHead>Quantidade de Cupons</TableHead>
            <TableHead className="relative">
              <span className="sr-only">Ações</span>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {companies.map((company) => (
            <TableRow key={company.id}>
              <TableCell>{company.company_name}</TableCell>
              <TableCell>{company.coupon_quantity}</TableCell>
              <TableCell className="text-right space-x-2">
                <Button
                  variant="ghost"
                  onClick={() => onManageCoupons(company)}
                  title="Cupons"
                >
                  <Ticket className="h-4 w-4 text-primary-600" />
                </Button>
                <Button
                  variant="ghost"
                  onClick={() => onEdit(company)}
                  title="Editar"
                >
                  <Pencil className="h-4 w-4" />
                </Button>
                <Button
                  variant="ghost"
                  onClick={() => onDelete(company)}
                  title="Excluir"
                >
                  <Trash2 className="h-4 w-4 text-red-600" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default CompanyList;